import Attendance from "../../container/users/student/studenttime/Attendance";

export const uiRoutes = {
  //Webiste

  website: {
    home: "/",
    services: "/services",
    project: "/projects",
    collegeRegister: "/college-register",
    mentorRegister: "/mentor-register",
    roboticLab: "/robotic-lab",
    addProjectRequirements: "/add-project-requirements",
    quize: "/quize",
    quizeShow: "/quize/show/:slug",
    programs: "/programs",
    programDetails: "/program/details/:slug",
    kids: "/kids",
    kidsCourseDetail: "/kids-course-detail-Page",
    roboticSyllabus: "/robotic-syllabus",
    campusToCorporate: "/campus-to-corporate",
    roboticRegister: "/robotical-register",
    ojt: "/ojt",
    hireUs: "/hire-us",
  Contact:"/contactus",
  casestudy:"/case-study",
  casestudydetails:"/case-study/details/:slug",
  //blog
  blogs:"/blogs",
  blogsdetails:"/blogs/:slug",

  //
  },

  auth: {
    login: "/login",
    logout: "/logout",
    changePassword: "/change-password",
  },

  home: "/home",
  // Admin Routes


  
  admin: {
    modules: {
      add: "/modules-add",
      edit: "/modules/edit/:id",
      list: "/modules/list",
    },
    projects: {
      add: "/projects/add",
      edit: "/projects/edit/:id",
      list: "/projects/list",
    },
 
 quiz: {
      add: "/quiz/add",
      edit: "/quiz/edit/:slug",
      list: "/quiz/list",
      questionlist:'/question-list/:slug'
    },

    program: {
      add: "/program/add",
      edit: "/program/edit/:id",
      list: "/program/list",
    },

    homeBanner: {
      list: "/homebanner-list",
      add: "/add-homebanner",
      edit: "/edit-homebanner/:id",
    },
    roboticSyllabus: {
      add: "/robotic-syallbus/add",
      edit: "/robotic-syallbus/edit/:id",
      list: "/robotic-syallbus/list",
    },

    testimonial: {
      add: "/testimonial/add",
      edit: "/testimonial/edit/:id",
      list: "/testimonial/list",
    },

    services: {
      add: "/service/add",
      edit: "/service/edit/:id",
      list: "/service/list",
    },
    roadmap:{
      add: "/roadmap/add",
      edit: "/roadmap/edit/:id",
      list: "/roadmap/list",
    },
    student:{
      add:"/admin/add-student",
      list: "/admin/student-list",

    },
    mentor:{
         list:"/mentor/list",
         add:"/mentor/assign/:mentorId",
    },
    programservice:{
      add:"/program-service/add",
      list:"/program-service/list",
      edit:"/program-service/edit/:id",
    },
    roboticskit:{
      add:"/roboticskit/add",
      list:"/roboticskit/list",
      edit:"/roboticskit/edit/:id",
    },
      roboticsimage:{
      add:"/roboticsimage/add",
      list:"/roboticsimage/list",
      edit:"/roboticsimage/edit/:id",
    },
    showattendance:"/show/attendance",
    casestudy:{
      add:"/case-study/add",
      list:"/case-study/list",
      edit:"/case-study/edit/:id"
    },
    blog:{
      add:"/blog/add",
      list:"/blog/list",
      edit:"/blog/edit/:id",
    },
    //case study 
      blogsgallery:{
      add:"/gallery/add",
      list:"/gallery/list",
      edit:"/gallery/edit/:id",
    }

  },

  // Mentor
  mentor: {
   
    assessment:{
      add:"/mentor-assessments/add",
      edit:"",
      list:"/mentor-assessments/list",
    },
    student:{
      list:"/mentor/student-list",
      profile:"/mentor/student-profile/:slug",
      task:"/mentor/student-task/:slug",
      session:"/mentor/student-session/:slug"
    },
      groups:{
      list:"/mentor/groups-list",
      add:"/mentor/groups-add",
      viewmember:"/mentor/student-list/:slug"

    },
    chatbot:{
      list:"/mentor/chatbot"
    },
    AssignTask:{
      add:"/mentor-assign-new-task",
      list:"/mentor-assigntask",
    },
    sessions: {
    add: "/mentor/session/new",     // :white_tick: For NewSession.jsx
    list: "/mentor/session/list",
    },
    Home:{
       Home:"/mentor/home",
    },
   CreateTask:{
    list:"/mentor/task-list",
    add:"/mentor/add-task",
    edit:"/mentor/edit-task/:id",
   }
  },

  // Student
  student: {

   assessment:{
        assessmentquestion:"/assessments-questions",
        assessmenttestresult:"/assessments-result",
        assessmentteststu:"/assessments-test",
        reassessment:"/assessments-exam"
       },
       dailytasks:{
        list:"/daily/student-task"
       },
    studentMentors: "/student-mentors",
    studentResources: "/student-resoures",
    studentSessions: "/student-sessions",
    studentChatbot: "/student-chatbot",
    studentProgress: "/student-progress",
    studenthome:"/road-map",
    studentprofile: "/student/profile",

    editProfile: "/student/profile/edit/:slug",

    attendance:{
    add:"/attendance/add",
    list:"/attendance/list"
  }
  },
  

};
